import $ from '/js/header/jquery.js';
import { JsonList } from '/js/jsonList/JsonList.js';

class DongList {
    constructor() {
        //
        this.mode = '';
        this.sicd = 11;
        this.gucd = 0;
        this.gunm = '';
        this.scd = 0;
        this.jsonList = new JsonList();
    }

    getMenuSiHtml(c) {
        //menu > si html
        let siList = '';
        for (let key in this.jsonList.Js_SI) {
            siList += `<li class='tab_20' id="sicd_${this.jsonList.Js_SI[key]}" data-si="${this.jsonList.Js_SI[key]}"><span>${key}</span></li>`;
        }
        
        const html = `
            <div class='tab_menu'>
                <ul>
                    ${siList}
                </ul>
                <div class='clear'></div>
            </div>
            ${this.getMenuGuHtml(c)}
        `;
        return html;
    }

    getMenuGuHtml(c) {
        //menu > si html
        let guList = '';
        for (let key in this.jsonList.Js_SIGU[c]) {
            guList += `
            <div id='gucd_${this.jsonList.Js_SIGU[c][key]}' class='tab_sub_gu ht' data-guCd="${this.jsonList.Js_SIGU[c][key]}" data-guNm='${key}'>
                <input type='radio' id='gucdCk_${this.jsonList.Js_SIGU[c][key]}'> ${key}
            </div>`;
        }
        
        const html = `
            <div class='tab_subNo input_box'>
                ${guList}
                <div class='clear'></div>
            </div>
            <div class='clear'></div><br>
        `;
        return html;
    }

    menu_data() {
        this.mode = 3;

        $.ajax({
            type: "POST",
            url: "/etc/res/bugaSrv.php",
            data: {
                mode: this.mode,
                sicd: this.sicd,
                gucd: this.gucd
            },
            dataType: "JSON",
            success: (data) => {
                let listHtml = "";
                if (data.rowCnt > 0) {
                    listHtml = data.item.map((item) => {
                        return `
                            <tr>
                                <td class='ifr_btn' id='num_${item.hdnix}'>
                                    <div style='padding-left:10px'>
                                        <span class='span_block f16' style='width:190px;'><span class='bold_700'>${item.hdnNm}</span> 행정복지센터</span> 
                                        <span class='span_block' style='min-width:120px;'>☎ ${item.hdnTl}</span>
                                        <span class='span_block'>${item.addr}<span class='f12 gray span_block'>[우:${item.hdnZp}]</span></span>
                                    </div>
                                </td>
                                <td class='right'>
                                    <a href='${item.hdnHome}' target='_blank'><span class='button btn_white button_tiny'>홈페이지</span></a>&nbsp;&nbsp;&nbsp;
                                    <span class='button btn_yellow button_tiny' onclick="window.open('https://map.kakao.com/link/to/${item.addr},${item.y},${item.x}')">
                                        <img src='/image/icon/icon_navi.png' alt='카카오 내비' width='13' valign='bottom'>길찾기
                                    </span>
                                </td>
                            </tr>
                        `;
                    }).join('');

                } else {
                    listHtml = "";
                }
                $("#leftBody").html(listHtml);
                $('.city').html(this.jsonList.Js_SIR[this.sicd] + " " + this.gunm);
                $('.no').html(data.rowCnt);
                //totCnt
                $("#totCnt").html(data.rowCnt);
            },
            error: function (xhr, status, error) {
            }
        });
    }

    menu_si(k) {
        this.sicd = k;
        //si
        var html = this.getMenuSiHtml(k);
        $("#menu_block").html(html);

        //si tab 선택
        $("[id^='sicd_']").removeClass("on");
        $("#sicd_" + k).addClass("on");

        //si 선택시 구 전체초기화
        //TK_SD['gucd']=Object.values(Js_SIGU[k])[0]; > ie11오류
        var scd = Object.keys(this.jsonList.Js_SIGU[this.sicd]).map((i) => {
            return this.jsonList.Js_SIGU[this.sicd][i];
        });
        this.gucd = scd[0];

        $("#gucd_" + this.gucd).addClass("on");
        $("#gucdCk_" + this.gucd).prop("checked", true);
        //data call
        this.menu_data();
    }

    menu_gu(k, g) {
        this.gucd = k;
        this.gunm = g;
        //gu tab 선택
        $("[id^='gucd_']").removeClass("on");
        $("#gucd_" + k).addClass("on");

        $("[id^='gucdCk_']").prop("checked", false);
        $("#gucdCk_" + k).prop("checked", true);
        //data call
        this.menu_data();
    }
}


$(() => {
    var dongList = new DongList();
    dongList.menu_si(dongList.sicd);

    // tab_menu > ul > .tab_20 클릭 이벤트
    $(document).on('click', '.tab_20', (e) => {
        const siCode = $(e.currentTarget).data('si');
        dongList.menu_si(siCode);
    });

    // tab_sub_gu 클릭 이벤트
    $(document).on('click', '.tab_sub_gu', (e) => {
        const guCode = $(e.currentTarget).data('gucd');
        const guName = $(e.currentTarget).data('gunm');
        dongList.menu_gu(guCode, guName);
    });
});